var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('van-loading',{attrs:{"color":"#1989fa","size":"48px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }